var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProblems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x81\xB1",
    d: "M12.8567 9.39431C13.2315 10.0503 12.763 10.8702 11.9899 10.8702H1.98666C1.21358 10.8702 0.745046 10.0503 1.11987 9.39431L6.1332 0.866962C6.50803 0.211013 7.46853 0.211013 7.86679 0.866962L12.8567 9.39431ZM6.43775 3.56104V6.55967C6.43775 6.88764 6.71887 7.12191 6.99999 7.12191C7.30454 7.12191 7.56224 6.88764 7.56224 6.55967V3.56104C7.56224 3.25649 7.30454 2.9988 6.99999 2.9988C6.67202 2.9988 6.43775 3.25649 6.43775 3.56104ZM6.99999 9.37088C7.39825 9.37088 7.72622 9.04291 7.72622 8.64465C7.72622 8.2464 7.39825 7.91842 6.99999 7.91842C6.57831 7.91842 6.25034 8.2464 6.25034 8.64465C6.25034 9.04291 6.57831 9.37088 6.99999 9.37088Z",
    fill: "#f1a1a1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblems);
export default __webpack_public_path__ + "static/media/problems.acfbfe5830805bf8a4db26272032c9bd.svg";
export { ForwardRef as ReactComponent };